import { render } from "./viewEvent.vue?vue&type=template&id=ae197ef4&scoped=true"
import script from "./viewEvent.vue?vue&type=script&lang=js"
export * from "./viewEvent.vue?vue&type=script&lang=js"

import "./viewEvent.vue?vue&type=style&index=0&id=ae197ef4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae197ef4"]])

export default __exports__